import { tooltipCopy } from 'Modules/Plans/helpers';
import { formatNumberToKNotation, toDecimalPoint } from '@round/utils';
import styles from './HeadlineStats.module.css';
import { InstagramUserStatsCache, TiktokUserStatsCache } from '@round/api';
import { Indicators } from '@round/whitelabel-ui';
import { SkeletonizedValue } from '@round/ui-kit';

type Props = {
    data: TiktokUserStatsCache | InstagramUserStatsCache | null | undefined;
    isLoading: boolean;
};

export default function HeadlineStats({ data, isLoading }: Props) {
    const followerCount = data?.follower_count;
    const avgPostViews = data?.avg_post_views;

    const stats = [
        {
            label: 'Followers',
            value: followerCount ? formatNumberToKNotation(followerCount) : '-',
        },
        {
            label: 'Engagement Rate',
            value: data?.avg_engagement_rate ? `${toDecimalPoint(data?.avg_engagement_rate * 100, 2)}%` : '-',
            tooltip: tooltipCopy.engagementRate,
        },
        {
            label: 'Average Video Plays',
            value: avgPostViews ? formatNumberToKNotation(avgPostViews) : '-',
        },
    ];

    return (
        <Indicators.Container className={styles.headlineStats}>
            {stats.map(({ label, value, tooltip }) => (
                <Indicators.Item key={label}>
                    <Indicators.Label tooltip={tooltip}>{label}</Indicators.Label>
                    <Indicators.Value>
                        <SkeletonizedValue isInitialized={!isLoading}>{value}</SkeletonizedValue>
                    </Indicators.Value>
                </Indicators.Item>
            ))}
        </Indicators.Container>
    );
}
